import { minLength } from 'app/utils/validations'

export const userSearchFormValidator = values => {
  let fullSSNMsg = 'No other criteria should be entered if full SSN is provided'
  let fullVaEauthSecIdMsg = 'No other criteria should be entered if the VA Eauth Sec ID is provided'
  const minLength4 = minLength(4)
  const errors = {}
  // If the user has entered anything for secondary phone number or secondary phone number type code
  if (!(values.lastName || values.ssn || values.email || values.username) && (values.firstName && !values.ssnLastFour)) {
    errors.ssnLastFour = 'Last four digits of SSN are required if the only other value is the first name'
  }
  if (values.vaEauthSecId && values.firstName) {
    errors.firstName = fullVaEauthSecIdMsg
  }
  if (values.vaEauthSecId && values.lastName) {
    errors.lastName = fullVaEauthSecIdMsg
  }
  if (values.vaEauthSecId && values.username) {
    errors.username = fullVaEauthSecIdMsg
  }
  if (values.vaEauthSecId && values.email) {
    errors.email = fullVaEauthSecIdMsg
  }
  if (values.vaEauthSecId && values.ssnLastFour) {
    errors.ssnLastFour = fullVaEauthSecIdMsg
  }
  if (values.vaEauthSecId && values.ssn) {
    errors.vaEauthSecId = 'Only the SSN or the VA Eauth Sec ID should be provided'
    errors.ssn = 'Only the SSN or the VA Eauth Sec ID should be provided'
  }
  if (values.ssn && values.firstName) {
    errors.firstName = fullSSNMsg
  }
  if (values.ssn && values.lastName) {
    errors.lastName = fullSSNMsg
  }
  if (values.ssn && values.email) {
    errors.email = fullSSNMsg
  }
  if (values.ssn && values.ssnLastFour) {
    errors.ssnLastFour = fullSSNMsg
  }
  if (values.email && minLength4(values.email)) {
    errors.email = 'At least 4 characters required for email'
  }
  if (!values.exactEmail && values.email && minLength4(values.email)) {
    errors.email = 'At least 4 characters required for partial'
  }
  if (values.ssnLastFour && /[^0-9 ]/i.test(values.ssnLastFour)) {
    errors.ssnLastFour = 'Only numeric characters are allowed'
  }
  if (values.ssn && /[^0-9 ]/i.test(values.ssn)) {
    errors.ssn = 'Only numeric characters are allowed'
  }
  return errors
}